import API from 'services/api';
import i18n from 'services/i18n';
import showErrorAlert, { parseError } from 'services/errorHandler';
import {
  SIMULATE_ADD_PAYMENT_METHOD_FAIL,
  SIMULATE_ADD_PAYMENT_METHOD_START,
  SIMULATE_ADD_PAYMENT_METHOD_SUCCESS,
  SIMULATE_COMPLETE_PAYMENT_FAIL,
  SIMULATE_COMPLETE_PAYMENT_START,
  SIMULATE_COMPLETE_PAYMENT_SUCCESS,
  THREE_DS_TIMEOUT
} from 'redux/constants/3ds';
import { Dispatch } from 'redux';
import { ERROR_CREDENTIALS_PAYMENT, ERROR_CREDENTIALS_REDIRECT } from 'consts/3ds';
import { isEqual } from 'lodash-es';

const simulateCompletePaymentStart = (loadingError: boolean) => ({
  type: SIMULATE_COMPLETE_PAYMENT_START,
  payload: { loadingError }
});

const simulateCompletePaymentSuccess = (data: Record<string, any>) => ({
  type: SIMULATE_COMPLETE_PAYMENT_SUCCESS,
  payload: { data }
});

const simulateCompletePaymentFail = (error: string) => ({
  type: SIMULATE_COMPLETE_PAYMENT_FAIL,
  payload: { error }
});

const simulateAddPaymentMethodStart = (loadingError: boolean) => ({
  type: SIMULATE_ADD_PAYMENT_METHOD_START,
  payload: { loadingError }
});

const simulateAddPaymentMethodSuccess = (data: Record<string, any>) => ({
  type: SIMULATE_ADD_PAYMENT_METHOD_SUCCESS,
  payload: { data }
});

const simulateAddPaymentMethodFail = (error: string) => ({
  type: SIMULATE_ADD_PAYMENT_METHOD_FAIL,
  payload: { error }
});

export const set3DSTimeout = () => ({
  type: THREE_DS_TIMEOUT
});

export const simulateCompletePayment =
  ({ token, param1, param2 }: { token: string; param1: string; param2: string }) =>
    async (dispatch: Dispatch<any>) => {
      try {
        dispatch(
          simulateCompletePaymentStart(
            isEqual(ERROR_CREDENTIALS_PAYMENT, { param1, param2 })
          )
        );

        const data = {
          param1,
          param2,
          payment_id: token
        };

        const response = await API.post(
          'hosted/simulators/complete-payment-simulator',
          data
        );
        const { data: payment } = response.data;
        dispatch(simulateCompletePaymentSuccess(payment));
      } catch (error) {
        const { status } = parseError(error);
        dispatch(simulateCompletePaymentFail(status?.error_code || status?.message));
        showErrorAlert({
          error: i18n.t('3ds_simulator.missing_token_error'),
          custom: true
        });
      }
    };

export const simulateAddPaymentMethodToCustomer =
  ({ token, param1 }: { token: string; param1: string; param2: string }) =>
    async (dispatch: Dispatch<any>) => {
      try {
        const error = param1 === ERROR_CREDENTIALS_REDIRECT.param1;
        dispatch(simulateAddPaymentMethodStart(error));

        const data = {
          token,
          gateway_token: param1,
          status: error ? 'error' : 'success'
        };

        const response = await API.post(
          'hosted/simulators/add-payment-method-to-customer-simulator',
          data
        );
        const { data: result } = response.data;
        dispatch(simulateAddPaymentMethodSuccess(result));
      } catch (error) {
        const { status } = parseError(error);
        dispatch(simulateAddPaymentMethodFail(status?.error_code || status?.message));
        showErrorAlert({
          error: i18n.t('3ds_simulator.missing_token_error'),
          custom: true
        });
      }
    };
